import { computed, Ref } from 'vue'
import { useRoute } from 'vue-router'
import { MenuItem, SubMenuItem } from '../defaultMenuItems'

export function useActiveMenu(menuitems: Ref<MenuItem[]>) {
  const route = useRoute()

  function isCurrentPath(path: string, exact = false): boolean {
    // Reference route.path so any computed using isCurrentPath re-runs on navigation
    void route.path
    if (!path) return false
    const sanitizedPath = path.split('?')[0]
    // Use window.location.pathname to get the full URL path, since in Vue Router 4
    // route.path is relative to the history base and router.options.base is undefined.
    const currentPath = window.location.pathname.split('/').filter(Boolean)
    const targetPath = sanitizedPath.split('/').filter(Boolean)
    const match = targetPath.every((e, i) => e === currentPath[i])
    if (exact) {
      return currentPath.length === targetPath.length && match
    }
    return match
  }

  function hasIcons(item: MenuItem): number {
    return item.items!.filter(x => x.icon && x.icon !== 'null').length
  }

  const activeMenuItem = computed<MenuItem | undefined>(() => {
    const items = menuitems.value
    const exactMatch = items?.find((item: MenuItem) => isCurrentPath(item.path!, true))
    if (exactMatch) return exactMatch
    const activeParent = items?.find((item: MenuItem) =>
      item.items?.some((submenu: SubMenuItem) => isCurrentPath(submenu.path!, true))
    )
    return activeParent || items?.find((item: MenuItem) => isCurrentPath(item.path!, false))
  })

  return { activeMenuItem, isCurrentPath, hasIcons }
}
